export default "__VITE_ASSET__CTvvX1yg__"